import { render, staticRenderFns } from "./FooterPhysio.vue?vue&type=template&id=56a1eae6&"
import script from "./FooterPhysio.vue?vue&type=script&lang=js&"
export * from "./FooterPhysio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterPhysio.vue
// module id = null
// module chunks = 